import LivestreamProductVariationEntity from './LivestreamProductVariationEntity';

export default class LivestreamProductEntity {
    id: number = 0;
    name: string = '';
    livestreamPrice: number = 0;
    livestreamPriceText: string = '';
    /** Giá gốc trước giảm affiliate (chỉ có ở `/dat-hang`), 0 = không giảm. */
    originalPrice: number = 0;
    images: string[] = [];
    sizes: string[] = [];
    variations: LivestreamProductVariationEntity[] = [];
    isHasStock: boolean = false;
}
